import React, { Suspense, lazy, useEffect, useState } from 'react';
import { Toaster } from './toaster';
import './index.css';

const HomePage = lazy(() => import('./pages/HomePage'));
const FAQPage = lazy(() => import('./pages/FAQPage'));

function App() {
  const [path, setPath] = useState(
    typeof window !== 'undefined' ? window.location.pathname : '/'
  );

  useEffect(() => {
    const updatePath = () => setPath(window.location.pathname);
    window.addEventListener('popstate', updatePath);
    window.addEventListener('app:navigate', updatePath as EventListener);
    return () => {
      window.removeEventListener('popstate', updatePath);
      window.removeEventListener('app:navigate', updatePath as EventListener);
    };
  }, []);

  return (
    <>
      <Toaster />
      <Suspense fallback={null}>
        {path.includes('faqs') ? <FAQPage /> : <HomePage />}
      </Suspense>
    </>
  );
}

export default App;
